import { render, staticRenderFns } from "./TransactionFee.vue?vue&type=template&id=cb20c6d8"
import script from "./TransactionFee.vue?vue&type=script&lang=js"
export * from "./TransactionFee.vue?vue&type=script&lang=js"
import style0 from "./TransactionFee.vue?vue&type=style&index=0&id=cb20c6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports